export default "__VITE_ASSET__Dlbhd5BT__"